import * as React from "react";
import { forwardRef } from "react";
const RearHatchIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M8.873 15.765c1.295 0 2.411.762 2.929 1.862h2.29c.803 0 1.261-.542 1.261-.99v-3.674l-.011-.261H2.64a.75.75 0 1 1 0-1.5h3.493L5.028 7.505H2.716a.75.75 0 1 1 0-1.5h9.868a2.85 2.85 0 0 1 .312.017c.491-.827 1.125-1.674 2.145-2.031l.097-.027 3.248-.665a4.076 4.076 0 0 1 1.419-.039l2.265.335.075.015a.75.75 0 0 1-.218 1.477l-.076-.008-2.265-.334a2.586 2.586 0 0 0-.899.025l-3.185.652c-.467.177-.831.582-1.237 1.239l.096.095c.29.305.518.687.712 1.044l.184.345.029.061 1.155 2.731a5.21 5.21 0 0 1 .411 2.029v3.674c0 1.474-1.342 2.49-2.762 2.49h-1.986a3.24 3.24 0 0 1-3.233 3.119 3.24 3.24 0 0 1-3.226-2.984H2.641a.75.75 0 1 1 0-1.5h3.243a3.237 3.237 0 0 1 2.989-1.996zm0 1.5a1.74 1.74 0 1 0 0 3.48 1.74 1.74 0 1 0 0-3.48zm-1.174-6.063h7.228l-1.009-2.385c-.261-.489-.433-.808-.643-1.03-.168-.177-.353-.282-.69-.282H6.594l1.105 3.697z"
}));
const ForwardRef = forwardRef(RearHatchIcon);
export default ForwardRef;